import { createApp, Fragment, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import type { DefineComponent, Plugin } from 'vue'
import ReleaseUpdateDialog from './components/ReleaseUpdateDialog.vue'
// import AuthLayout from './pages/AuthLayout.vue'

import '@packages/design/design.css'
import './webawesome'
import './assets/contentblocks.css'
// import './assets/main.css'

createInertiaApp({
  // title: 'foobar',
  resolve: (name: string) =>
    //   const pages = import.meta.glob('./pages/**/*.vue', { eager: true })
    //   let page = pages[`./pages/${name}.vue`]
    //   page.default.layout = page.default.layout || AuthLayout

    //   return page
    // },
    resolvePageComponent(
      `./pages/${name}.vue`,
      import.meta.glob<DefineComponent>('./pages/**/*.vue'),
    ),
  setup({
    el,
    App,
    props,
    plugin,
  }: {
    el: Element
    App: DefineComponent
    props: Record<string, unknown>
    plugin: Plugin
  }) {
    // The release prompt sits beside the page so it survives navigation.
    createApp({ render: () => h(Fragment, [h(App, props), h(ReleaseUpdateDialog)]) })
      .use(plugin)
      .mount(el)
  },
  progress: {
    color: '#4B5563',
  },
})
